var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 1.82143C17.325 1.07143 16.7625 0.535714 15.975 0.321429C14.625 1.91586e-07 8.88749 0 8.88749 0C8.88749 0 3.26251 1.91586e-07 1.80001 0.321429C1.01251 0.535714 0.449997 1.07143 0.224997 1.82143C-3.43658e-06 3.21429 0 6 0 6C0 6 3.41982e-06 8.78571 0.337503 10.1786C0.562503 10.9286 1.125 11.4643 1.9125 11.6786C3.2625 12 9 12 9 12C9 12 14.625 12 16.0875 11.6786C16.875 11.4643 17.4375 10.9286 17.6625 10.1786C18 8.78571 18 6 18 6C18 6 18 3.21429 17.55 1.82143ZM7.19999 8.57143V3.42857L11.925 6L7.19999 8.57143Z",
    fill: "#6F6D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutub);
export default __webpack_public_path__ + "static/media/youtub.dfe3f43cc235573fef1c98240832299c.svg";
export { ForwardRef as ReactComponent };